import { AtmosphereCard } from "./AtmosphereCard";
import { ATMOSPHERES } from "./AtmospheresData";
import gsap from 'gsap';
import { hexToRgb } from "./utils";

const CARD_MARGIN = 18;
const CARD_SIDE_MARGIN = 48;
const CARD_BOTTOM_MARGIN = 48;//88;
const TOP_MARGIN = 48; //80;
const TITLE_REDUCED_MAX_HEIGHT = 220;
const CARD_WIDTH = 334;
const CARD_HEIGHT = 588;
const MIN_CARD_HEIGHT = 46;


class AtmosphereSelector {
  constructor(canvas, canvasContainer, translator) {
    this.translator = translator;
    this.screenSize = { width: 0, height: 0 };
    this.canvas = canvas;
    this.canvasContainer = canvasContainer;
    this.introContainer = document.querySelector(".intro-container");
    this.container = document.getElementById('atmospheres');
    this.btn = document.getElementById('atmospheres-btn');
    this.subtitleElement = document.getElementById('atmosphere-subtitle');
    this.backBtn = document.getElementById("atmosphere-back-btn");
    this.dialogBox = document.getElementById("atmosphere-change-dialog");
    this.dialogContinueBtn = document.getElementById("dialog-continue");
    this.dialogBackBtn = document.getElementById("dialog-back");
    this.currentAtmosphere = null;
    // this is used to save the choice of the user
    // while we show the dialog box
    this.pendingAtmosphere = null;
    this.atmosphereCards = [];
    this.cardWidth = 0;
    this.cardHeight = 0;
    this.isCanvasReduced = false;
    this.selectedId = '';
    this.color = '';
    this.isMobileLayout = false;
    this.isFirstPick = true;
    this.hasDialogBeenShown = false;

    let i = 0;
    for (const atmosphere of ATMOSPHERES) {
      const card = new AtmosphereCard(atmosphere, i, this.translator);
      this.atmosphereCards.push(card);
      this.container.appendChild(card.element);
      card.element.addEventListener('click', () => {
        // Show the warning that the painting will be reset
        if (!this.hasDialogBeenShown && !this.isFirstPick && this.currentAtmosphere != card.data) {
          this.showDialogBox();
          this.pendingAtmosphere = card.data;
        } else {
          this.currentAtmosphere = card.data;
          this.sendEvent("atmosphereChanged");
        }

      });
      i++;
    }
    this.shown = false;
    this.btn.addEventListener('click', () => {
      this.show(false);
    });

    this.backBtn.addEventListener('click', () => {
      this.hide();
    })

    this.dialogContinueBtn.addEventListener("click", () => {
      this.currentAtmosphere = this.pendingAtmosphere;
      this.sendEvent("atmosphereChanged");
      this.hideDialogBox();
    });

    this.dialogBox.addEventListener("click", () => {
      this.pendingAtmosphere = null;
      this.hide();
      this.hideDialogBox();
    });

    // this.container.addEventListener("click", () => {
    //   this.hide();
    // });
  }

  hideDialogBox() {
    gsap.to(this.dialogBox, {
      duration: 0.4,
      autoAlpha: 0,
      onComplete: () => { this.dialogBox.style.visibility = "hidden" },
    });
  }

  showDialogBox() {
    this.dialogBox.style.visibility = "visible";
    gsap.to(this.dialogBox, { duration: 0.4, autoAlpha: 1 });
    this.hasDialogBeenShown = true;
  }

  changeColor(color, complementaryColor) {
    this.color = color.toLowerCase();
    const complementaryColorRgb = hexToRgb(complementaryColor);
    this.btn.style.color = complementaryColor;
    //this.btn.style.color = color;
    this.btn.style.backgroundColor = color;
    //this.btn.style.backgroundColor = complementaryColor;
    this.btn.style.boxShadow =
      `0px 2px 6px rgba(${complementaryColorRgb[0]},${complementaryColorRgb[1]},${complementaryColorRgb[2]}, 0.12)`;
    if (this.selectedId.length) {
      this.select(this.selectedId);
    }

    if (!this.hasDialogBeenShown) {
      const btnBgColor = this.color !== '#ffffff' ? color : complementaryColor;
      const btnColor = this.color !== '#ffffff' ? complementaryColor : color;
      this.dialogContinueBtn.style.backgroundColor = btnBgColor;
      this.dialogContinueBtn.style.color = btnColor;
      this.dialogBackBtn.style.backgroundColor = btnBgColor;
      this.dialogBackBtn.style.color = btnColor;
    }

    //this.subtitleElement.style.color = color;
  }

  isValidAtmosphere(id) {
    for (const card of this.atmosphereCards) {
      if (card.data.id === id) {
        return true;
      }
    }
    return false;
  }

  select(id, fromSharing = false) {
    for (const card of this.atmosphereCards) {
      if (card.data.id === id) {
        this.currentAtmosphere = card.data;
        card.select(this.color);
      } else {
        card.unselect();
      }
    }
    this.selectedId = id;
    if (!fromSharing) {
      this.isFirstPick = false;
    }
  }

  resize(size, andReduced) {
    const isShowingReducedTitle = andReduced || this.isCanvasReduced;
    const topMargin = isShowingReducedTitle ? 180 : TOP_MARGIN;
    const sideMargin = size.width < 900 ? 10 : CARD_SIDE_MARGIN;
    const cardMargin = size.width < 1000 ? 8 : CARD_MARGIN;
    this.screenSize.width = size.width;
    this.screenSize.height = size.height;
    const availableHeight =
      this.screenSize.height - CARD_BOTTOM_MARGIN * 2 - topMargin;
    const cardCount = this.atmosphereCards.length;
    const backButtonWidth = this.backBtn.offsetWidth;
    let backButtonY = 0;
    const backButtonX = this.screenSize.width / 2 - backButtonWidth / 2;

    this.cardWidth = Math.min(
      CARD_WIDTH,
      (this.screenSize.width -
        sideMargin * 2 -
        cardMargin * (cardCount - 1)) /
      cardCount
    );
    this.cardHeight = (this.cardWidth * CARD_HEIGHT) / CARD_WIDTH;

    if (
      this.cardHeight > availableHeight ||
      this.cardHeight > this.screenSize.height / 2
    ) {
      this.cardHeight = Math.min(this.screenSize.height / 2, availableHeight);
      this.cardWidth = (this.cardHeight * CARD_WIDTH) / CARD_HEIGHT;
    }

    this.cardWidth = Math.floor(this.cardWidth);
    this.cardHeight = Math.max(Math.floor(this.cardHeight), MIN_CARD_HEIGHT);
    if (this.cardWidth < 270) {
      this.container.classList.add("smaller");
    } else {
      this.container.classList.remove("smaller");
    }
    let cardsX =
      this.screenSize.width / 2 -
      ((this.cardWidth + cardMargin) * cardCount - cardMargin) / 2;
    //const cardY = topMargin + availableHeight / 2 - this.cardHeight / 2 + CARD_BOTTOM_MARGIN;
    let cardY = Math.max(this.screenSize.height / 2 - this.cardHeight / 2, topMargin + CARD_MARGIN);
    // If the screen is really narrow (on mobile), display the cards into a grid.
    if (this.cardWidth < 100) {
      this.isMobileLayout = true;
      this.cardWidth = Math.min(
        CARD_WIDTH,
        (this.screenSize.width -
          sideMargin * 2 -
          cardMargin * (cardCount - 1)) /
        2
      );
      this.cardHeight = Math.max(MIN_CARD_HEIGHT, availableHeight / 2); //(this.cardWidth * CARD_HEIGHT) / CARD_WIDTH;
      // cardsX = cardMargin + sideMargin;
      cardsX =
        this.screenSize.width / 2 -
        ((this.cardWidth + cardMargin) * 2 - cardMargin) / 2;
      cardY = topMargin;
    } else {
      this.isMobileLayout = false;
    }

    gsap.set(this.subtitleElement, {
      y: Math.max(topMargin + 10, cardY / 2),
    });
    let i = 0;
    let j = 0;

    for (const card of this.atmosphereCards) {
      // If the screen is very narrow (mobile), display a grid of 2x2
      if (this.isMobileLayout) {
        //increase row each 2 elements
        if (i % 2 == 0 && i > 0) {
          j++;
        }
        const rowHeight =
          cardY + this.cardHeight * j + (cardMargin + sideMargin) * j;
        card.resize(
          cardsX + (i % 2) * (this.cardWidth + cardMargin),
          rowHeight,
          this.cardWidth,
          this.cardHeight
        );
        backButtonY = rowHeight + this.cardHeight + CARD_MARGIN;
      }

      // Else, display it in a single row
      else {
        card.resize(
          cardsX + i * (this.cardWidth + cardMargin),
          cardY,
          this.cardWidth,
          this.cardHeight
        );
        backButtonY = cardY + this.cardHeight + CARD_MARGIN;
      }
      i++;
    }

    //place the back button
    this.backBtn.style.top = backButtonY + 'px';
    this.backBtn.style.left = backButtonX + "px";

    if (isShowingReducedTitle) {
      this.reduceCanvas();
    }
  }

  reduceCanvas() {
    this.isCanvasReduced = true;
    const scale = Math.min(TITLE_REDUCED_MAX_HEIGHT, (this.canvas.height - this.cardHeight - CARD_MARGIN * 2)) / this.canvas.height;
    // this.canvasContainer.style.transformOrigin = 'top center';
    // gsap.to(this.canvasContainer, { duration: 0.6, ease: 'circ.inOut', scale: scale });
    // reduce the lottie animation
    this.introContainer.style.transformOrigin = "top center";
    gsap.to(this.introContainer, { duration: 0.6, ease: 'circ.inOut', scale: scale });
  }

  resetCanvas() {
    this.isCanvasReduced = false;
    // gsap.to(this.canvasContainer, { duration: 0.4, ease: 'circ.inOut', scale: 1 });
  }

  getData(index) {
    return index in ATMOSPHERES ? ATMOSPHERES[index] : null;
  }

  getDataById(id) {
    for (const data of ATMOSPHERES) {
      if (data.id == id) {
        return data;
      }
    }
    return null;
  }

  hide() {
    this.shown = false;
    let i = 0;
    gsap.to(this.subtitleElement, { duration: 0.4, autoAlpha: 0 });
    for (const card of this.atmosphereCards) {
      card.hide(i * 0.04, i == this.atmosphereCards.length - 1 ? this.onHidden : null, this);
      i++;
    }
    if (!this.isFirstPick) gsap.to(this.backBtn, { duration: 0.3, autoAlpha: 0, scale: 0.8 });
    gsap.to(this.container, { duration: 0.8, delay: i * 0.04, autoAlpha: 0, ease: 'none' });
    this.resetCanvas();
    this.sendEvent('atmosphereMenuUpdate');
    this.hideDialogBox();
  }

  onHidden() {
    gsap.to(this.btn, { duration: 0.6, ease: 'back.out', scale: 1, autoAlpha: 1 });
  }

  show(andReduce = true) {
    if (!andReduce) {
      this.container.classList.add('intro-completed');
    } else {
      this.container.classList.remove('intro-completed');
    }
    this.resize(this.screenSize, andReduce);
    gsap.to(this.container, { duration: 0.6, autoAlpha: 1 });
    this.shown = true;
    let delay = andReduce ? 0.2 : 0.2;
    for (const card of this.atmosphereCards) {
      card.show(delay);
      delay += 0.06;
    }
    gsap.to(this.subtitleElement, { duration: 0.6, autoAlpha: 1 });
    if (!this.isFirstPick) gsap.to(this.backBtn, {
      duration: 0.3,
      delay: delay + 0.06,
      scale: 1,
      autoAlpha: 1,
    });
    gsap.to(this.btn, { duration: 0.3, ease: 'back.in', scale: 0.8, autoAlpha: 0 });

    this.sendEvent('pause');
    this.sendEvent('atmosphereMenuUpdate');
  }

  sendEvent(eventName) {
    const event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
    document.dispatchEvent(event);
  }
}

export { AtmosphereSelector }